import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CancellationPolicy = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center font-inter text-14 fw-500 text-light-1">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Refund & Cancellation Policy</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container layout-pt-sm layout-pb-md">
        <h3 className="">Refund & Cancellation Policy</h3>
        <div>
          <p className="py-20 text-justify">
            <b>1. Event Cancellations and Changes</b> If an event is cancelled,
            postponed, suspended, or delayed for any reason, FitizenIndia.com
            will adhere to the guidelines provided by the Organizers.
            FitizenIndia.com will not make any refunds nor be liable for any
            loss caused by such cancellations, postponements, suspensions, or
            delays.
          </p>
          <p className="py-10 text-justify">
            It is your responsibility to ascertain whether an event has been
            cancelled and the date and time of any rearranged event. If an event
            is cancelled or rescheduled, we will use reasonable efforts to
            notify ticket holders of the cancellation once we have received the
            relevant authorization from the Event Organizer. We do not guarantee
            that ticket holders will be informed of such cancellation before the
            date of the event.
          </p>
          <p className="py-20 text-justify">
            <b>2. Venue and Event Organizer Rules</b> Tickets are issued subject
            to the Rules and Regulations of the venue or Event Organizer. Full
            details are available from the Event Organizers. Breach of any of
            these Rules and Regulations or any unacceptable behavior likely to
            cause damage, nuisance, or injury shall entitle the venue or Event
            Organizer to eject you from the venue.
          </p>

          <p className="py-10 text-justify">
            The Event Organizers may conduct security searches to ensure the
            safety of patrons. FitizenIndia.com will not be responsible for any
            tickets that are lost or stolen.
          </p>
          <p className="py-10 text-justify">
            Tickets may be restricted to a maximum number per person, per credit
            card, and, for some events, a restriction may apply per household.
            We reserve the right to cancel tickets without prior notice
            purchased in excess of this number.
          </p>
          <h5 className="py-10">Refund Policy</h5>
          <p className="py-20 text-justify">
            <b>1. Non-Refundable Reservations</b> Once an entry is received, no
            requests for refund of application fees will be entertained under
            any circumstances. Reservations for events are non-refundable.
          </p>
          <p className="py-20 text-justify">
            <b>2. Organizer-Based Refund Policy</b> Refund policy is subject to
            the Organizer’s terms and conditions. Our portal will act
            accordingly. Requests for refunds will be sent to the Organizers
            when needed.
          </p>
          <p className="py-20 text-justify">
            <b>3. Rejection of Application</b> If your application is rejected
            for any reason, the entry fee component paid will be refunded within
            14 working days. An applicable amount/percentage will be deducted as
            processing charges.
          </p>
          <p className="py-20 text-justify">
            <b>4. Non-Participation and Disqualification</b> Application fees
            will not be refunded due to non-participation, including failure by
            a confirmed participant to collect his/her bib from the Organizer or
            not being allowed to run on the race day due to high temperature or
            being unwell.
          </p>
          <p className="py-20 text-justify">
            <b>5. Refund Discrepancies</b> Any refund discrepancies must be
            brought to the attention of the event registration team immediately.
            Refund queries will not be entertained post [specific number of
            days] of the event.
          </p>

          <h5 className="py-10">Chargebacks</h5>
          <p className="py-20 text-justify">
            <b>1. Registration Confirmation</b> In the event that you do not
            receive an email confirmation of registration, you agree to click
            the "Send enquiry to organizer" link on the event page. You waive
            your rights to a chargeback for not receiving your tickets by not
            following this process and clicking that link. The Event Organizer
            will then reach out to you to provide your email confirmation of
            registration.
          </p>
          <p className="py-20 text-justify">
            <b>2. Event Participation</b> Once you check in to an event via
            signing a "SIGN IN" sheet or via other methods, you agree that you
            participated in the event and that your purchase was completely
            fulfilled. It is your obligation to store or keep a record of your
            email confirmation of registration and release FitizenIndia.com from
            any claims.
          </p>
        </div>
      </section>
    </>
  );
};

export default CancellationPolicy;
